import { createConsumer } from '@rails/actioncable'

// Consumer ActionCable (mesma origem; usa o cookie de sessão).
let consumer = null

export function getConsumer() {
  if (!consumer) consumer = createConsumer('/cable')
  return consumer
}
